var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_1291_91572"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,0,32)",
    clipPath: "url(#master_svg0_1291_91572)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,0,54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,27.848528L12.07574,31.92426Q12.16013,32.00866,12.27039,32.05433Q12.38065,32.1,12.5,32.1Q12.5591,32.1,12.61705,32.08847Q12.67501,32.07694,12.72961,32.05433Q12.78421,32.031710000000004,12.83334,31.99888Q12.88248,31.96605,12.92426,31.92426Q12.96605,31.88248,12.99888,31.83334Q13.03171,31.78421,13.05433,31.72961Q13.07694,31.67501,13.08847,31.61705Q13.1,31.55909,13.1,31.5Q13.1,31.38065,13.05433,31.27039Q13.00866,31.16013,12.92426,31.07574L12.92384,31.07531L8.42426,26.575736Q8.382480000000001,26.53395,8.33334,26.501118Q8.28421,26.468287,8.229610000000001,26.445672Q8.17501,26.423058,8.117049999999999,26.411529Q8.059090000000001,26.4,8,26.4Q7.94091,26.4,7.88295,26.411529Q7.82499,26.423058,7.77039,26.445672Q7.71579,26.468287,7.66666,26.501118Q7.61752,26.53395,7.57574,26.575736L3.075891,31.075580000000002L3.075736,31.07574Q2.991345,31.16013,2.945672,31.27039Q2.9,31.38065,2.9,31.5Q2.9,31.55909,2.911529,31.61705Q2.923058,31.67501,2.945672,31.72961Q2.968287,31.78421,3.001118,31.83334Q3.03395,31.88248,3.075736,31.92426Q3.117522,31.96605,3.166658,31.99888Q3.215793,32.031710000000004,3.27039,32.05433Q3.324986,32.07694,3.382946,32.08847Q3.4409052,32.1,3.5,32.1Q3.619347,32.1,3.72961,32.05433Q3.839873,32.00866,3.924264,31.92426L8,27.848528Z",
    fillRule: "evenodd",
    fill: "currentColor",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "media/ArrowIcon.bca6864f.svg";
export { ForwardRef as ReactComponent };